module.exports = __webpack_public_path__ + "img/2023big14.56b1d3ed.png";